import { Suspense } from 'react';

import { Outlet } from 'react-router-dom';

import AuthSectionImage from '../shared/AuthSectionImage';
import { Footer } from '../template/Footer';
import { Navbar } from '../template/navbar/Navbar';
import PageLoader from '../template/PageLoader';

const AuthLayout = () => {
  return (
    <div className="flex flex-auto flex-col justify-between min-h-screen ">
      <Navbar />
      <main className="flex-1 mt-14 grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-4 px-4 sm:px-6 md:px-8 py-4 sm:py-6 container">
        <AuthSectionImage />
        <Suspense fallback={<PageLoader />}>
          <div className="flex flex-col justify-center gap-4 md:gap-8 items-center relative">
            <div className="flex flex-col max-w-[340px] w-full space-y-6">
              <Outlet />
            </div>
          </div>
        </Suspense>
      </main>
      <Footer />
    </div>
  );
};
export default AuthLayout;
